import { useState } from "react";
import AbstractController from "../../../../../vendors/services/abstractController";
import ToastService from "../../../../../vendors/services/toastService";
import SuporteService from "../../../../services/suporte.service";
import { Mensagem } from "../../../../shared/mensagem/Mensagem";
import {
  Suporte,
  SuportePaginado,
  TP_SUPORTE_FALE_CONOSCO,
} from "../types/fale-conosco.types";

export default class FaleConoscoController extends AbstractController {
  private service: SuporteService;

  public registro: Suporte | null;
  public setRegistro: (value: Suporte | null) => void;
  public consultaConcluida: boolean;
  public setConsultaConcluida: (value: boolean) => void;

  constructor() {
    super();
    this.service = new SuporteService();

    [this.registro, this.setRegistro] = useState<Suporte | null>(null);
    [this.consultaConcluida, this.setConsultaConcluida] = useState(false);
  }

  init() {
    super.init();
    this.breadCrumbService.change([
      {
        id: "fale-conosco",
        label: "Fale conosco",
        url: "/fale-conosco/inicio",
      },
    ]);
    this.consultar();
  }

  consultar() {
    this.start();
    this.service
      .findAll({
        tipo: TP_SUPORTE_FALE_CONOSCO,
        page: 0,
        pageSize: 10,
      })
      .then((res) => {
        const resultado = res.result as SuportePaginado | null;
        this.setRegistro(resultado?.items?.[0] ?? null);
      })
      .catch(() => {
        this.setRegistro(null);
        ToastService.showError(Mensagem.ERRO);
      })
      .finally(() => {
        this.setConsultaConcluida(true);
        this.stop();
      });
  }
}
